import {useEffect, useState} from 'react'
import {useQuery} from '@tanstack/react-query'

import {BypassDataClient} from 'interfaces'
import {PoliciesService} from 'services/api'
import {
  createEmptyBypassData,
  type GetBypassQueryResponse,
  transformUrlBypassToClientData,
} from './useGetUrlAndApplicationBypass'
import {getUrlBypassResourceQueryKey} from './useGetUrlBypassResource'

interface GetUrlBypassQueryProps {
  policyName: string
  enabled?: boolean
}

export const useGetUrlBypass = ({
  policyName,
  enabled = true,
}: GetUrlBypassQueryProps): GetBypassQueryResponse => {
  const [bypassData, setBypassData] = useState<BypassDataClient>(
    createEmptyBypassData,
  )

  const {data, isLoading, isSuccess, isError, error, ...rest} = useQuery({
    queryKey: getUrlBypassResourceQueryKey(policyName),
    queryFn: () => PoliciesService.getUrlBypass(policyName),
    enabled,
    select: ({data}): BypassDataClient => transformUrlBypassToClientData(data),
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (!isLoading && data) {
      setBypassData(data)
    }
  }, [isLoading, data])

  return {
    data: bypassData,
    onUpdateBypassData: setBypassData,
    isLoading,
    isSuccess,
    isError,
    error,
    ...rest,
  }
}
